import React from "react";
import "../../assets/style/standings.css";

interface StandingsResultProps {
  driver_result: RaceResult[];
  poleman: string[] | null;
  fastest: string[] | null;
  most_leader: string[] | null;
  leaders: string[] | null;
  qualy: QualyResult[] | null;
  isDrivers: boolean;
  gp?: React.ReactNode;
}

const StandingsResult: React.FC<StandingsResultProps> = ({
  driver_result,
  poleman,
  fastest,
  most_leader,
  leaders,
  qualy,
  isDrivers,
  gp,
}) => {
  let value = "";
  let className = "standings-Empty";
  let raise1 = <></>;
  let raise2 = <></>;

  if (driver_result && driver_result.length > 0) {
    const result = driver_result[0];
    const qualy_pos = qualy?.[0]?.pos ?? null;
    const position = result.position;
    const time = result.time;
    const driver = result.username;
    const points = result.points;

    if (position === null && time !== null) {
      value = time;
      className = `standings-${time}`;
    } else if (position === null) {
      value = "DNP";
      className = "standings-DNP";
    } else if (time === "DNF") {
      value = "Ret";
      className = "standings-Ret";
    } else if (time === "DSQ" || time === "DQ") {
      value = "DSQ";
      className = "standings-DSQ";
    } else if (time === "NC") {
      value = "NC";
      className = "standings-OUT_OF_POINTS";
    } else if (typeof time === "string" && time.slice(-1) === "*") {
      value = `${position}†`;
    } else if (position !== null) {
      value = position.toString();
    }

    if (className === "standings-Empty") {
      if (position === 1) className = "standings-WINNER";
      else if (position === 2) className = "standings-SECOND";
      else if (position === 3) className = "standings-THIRD";
      else if (points > 0) className = "standings-POINTS";
      else className = "standings-OUT_OF_POINTS";
    }

    if (poleman && poleman.includes(driver)) className += " bold";
    if (fastest && fastest.includes(driver)) className += " italic";

    if (isDrivers) {
      if (
        Object.prototype.hasOwnProperty.call(result, "scoreable") &&
        result.scoreable === false
      ) {
        className += " med-opacity";
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(result, "team_scoreable") &&
        result.team_scoreable === false
      ) {
        className += " med-opacity";
      }
    }

    if (qualy_pos != null) {
      raise1 = <sup className="qualy-raise">{qualy_pos} </sup>;
    }

    if (most_leader && most_leader.includes(driver)) {
      raise2 = <sup> L*</sup>;
    } else if (leaders && leaders.includes(driver)) {
      raise2 = <sup> L</sup>;
    }
  } else {
    value = "";
  }

  if (gp != null) {
    return (
      <div className={`standings-results driver-results-gp ${className}`}>
        {gp}
        <span>
          {raise1}
          {value}
          {raise2}
        </span>
      </div>
    );
  }

  return (
    <td className={`standings-results ${className}`}>
      {raise1}
      {value}
      {raise2}
    </td>
  );
};

export default StandingsResult;
